import Api from '@/services/Api'

const HEADERURL = 'cxp/abonos/';
const ACTION_AGREGAR_CONTABILIZACION = 'agregar_contabilizacion';
const ACTION_APLICAR_CARGO = 'aplicar_cargo';
const ACTION_CERRAR = 'cerrar';
const ACTION_ANULAR = 'anular';
const ACTION_ABRIR = 'abrir';
const ACTION_AGREGAR_PAGO = 'agregar_pago';

export default {

    fetch(params) {

        return Api().get(HEADERURL, {

            params: params,

        });

    },

    getById(id) {

        return Api().get(`${HEADERURL}${id}`);

    },

    save(params) {
        if (params.id != null) {
            return Api().put(`${HEADERURL}${params.id}` + '/', params);
        }
        return Api().post(HEADERURL, params);

    },

    agregar_pago(id, params) {
        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_PAGO}/`, params);

    },

    agregar_contabilizacion(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_AGREGAR_CONTABILIZACION}/`, params);

    },

    aplicar_cargo(id, params) {

        return Api().post(`${HEADERURL}${id}/${ACTION_APLICAR_CARGO}/`, params);

    },

    abrir(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ABRIR}/`);

    },

    cerrar(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_CERRAR}/`);

    },

    anular(id) {

        return Api().post(`${HEADERURL}${id}/${ACTION_ANULAR}/`);

    },


}